<template>
  <v-card class="ma-3" :style="cardClass">
    <div class="d-flex justify-space-between pr-4">
      <h3 class="py-3 pl-4">
        RAW DATA
      </h3>
    </div>
    <data-card v-for="(item, i) in data.rawData" :key="i" :noMargin="true">
      <v-row :id="'raw-data-' + item.name">
        <div class="d-flex justify-space-between pr-7 pl-7" style="width:100%;">
          <span>{{ item.name }}</span>
          <span v-if="item.name != 'last_activity'" style="max-width:50%;">{{
            item.value
          }}</span>
          <span v-else>{{ getTimeValue(item.value) }}</span>
        </div>
      </v-row>
    </data-card>
  </v-card>
</template>

<script>
import moment from 'moment';
import ScreenDetailData from '@/mixins/ScreenDetailData';
import DataCard from '@/components/app/DataCard.vue';
import card from '@/mixins/card';
import { MobileView } from '@/mixins';

export default {
  components: {
    DataCard,
  },
  mixins: [ScreenDetailData, card, MobileView],
  methods: {
    inArray(value) {
      if (this.noDisplay.indexOf(value) < 0) {
        return true;
      }
      return false;
    },
    getTimeValue(time) {
      return moment(time).format('MM-DD-YYYY HH:mm:ss');
    },
  },
  computed: {
    cardClass() {
      if (this.showMobileView) {
        return 'width:95%;';
      }
      return 'width:calc(50% - 24px); overflow:hidden;';
    },
  },
};
</script>

<style></style>
